import { render, staticRenderFns } from "./receive-coupons.vue?vue&type=template&id=9f810458&scoped=true&"
import script from "./receive-coupons.vue?vue&type=script&lang=js&"
export * from "./receive-coupons.vue?vue&type=script&lang=js&"
import style0 from "./receive-coupons.vue?vue&type=style&index=0&id=9f810458&prod&lang=scss&"
import style1 from "./receive-coupons.vue?vue&type=style&index=1&id=9f810458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f810458",
  null
  
)

export default component.exports